import { Pipe, PipeTransform } from '@angular/core';
const HTML_REGEX = new RegExp(/<\/?[^>]+(>|$)/g);

export const stripHtml = (text: string): string => text?.replace(HTML_REGEX, '') ?? '';

@Pipe({ name: 'stripHtml' })
export class StripHtmlPipe implements PipeTransform {
  transform = stripHtml;
}
